import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";
import { MainInfoContentVariant } from "../../config/mainInfoTypeConfig";
import PackageContent from "./PackageContent";
import UrlResContent from "./UrlResContent";
import BrightcoveContent from "./BrightcoveContent";
import YoutubeContent from "./YoutubeContent";
import LinkedinContent from "./LinkedinContent";
import LtiContent from "./LtiContent";
import SurveyContent from "./SurveyContent";
import ClassContent from "./ClassContent";

interface ContentSectionProps extends WizardStepProps<ActivityWizardData> {
  variant: MainInfoContentVariant;
  locked?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({
  variant,
  data,
  setData,
  errors,
  locked = false,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const renderVariant = () => {
    switch (variant) {
      case "package":
        return (
          <PackageContent
            data={data}
            setData={setData}
            errors={errors}
            locked={locked}
          />
        );
      case "url-res":
        return <UrlResContent data={data} setData={setData} errors={errors} />;
      case "brightcove":
        return (
          <BrightcoveContent data={data} setData={setData} errors={errors} />
        );
      case "youtube":
        return <YoutubeContent data={data} setData={setData} errors={errors} />;
      case "linkedin":
        return (
          <LinkedinContent data={data} setData={setData} errors={errors} />
        );
      case "lti":
        return <LtiContent data={data} setData={setData} errors={errors} />;
      case "survey":
        return <SurveyContent data={data} setData={setData} errors={errors} />;
      case "class":
        return (
          <ClassContent
            data={data}
            setData={setData}
            errors={errors}
            locked={locked}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {t("sections.content.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: theme.palette.text.tertiary,
            mt: 0.5,
          }}
        >
          {t("sections.content.description")}
        </Typography>
      </Box>
      {renderVariant()}
    </Box>
  );
};

export default ContentSection;
